export namespace EeseCoverageActions {
  export class SetAllEeseCoverages {
    static readonly type = '[eeseCoverage] SetAllEeseCoverages';
    constructor() {}
  }

  export class SetMyEeseCoverages {
    static readonly type = '[eeseCoverage] SetMyEeseCoverages';
    constructor(public userId: string) {}
  }

  export class DeleteEeseCoverage {
    static readonly type = '[eeseCoverage] DeleteEeseCoverage';
    constructor(public eeseCoverageUid: string, public regBy: string) {}
  }

  export class UpdateItem {
    static readonly type = '[eeseCoverage] UpdateItem';
    constructor(public item: any) {}
  }

  export class ClearCache {
    static readonly type = '[eeseCoverage] ClearCache';
    constructor() {}
  }
}
